const isProductionEnvironment = process.env["NODE_ENV"] === "production";
const commonLocales = [
    "br",
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "nl",
    "pl",
    "ru",
    "zh"
];
const nonProdLocales = ["xx", "zz"];

const VALID_LOCALES = isProductionEnvironment
    ? commonLocales
    : ([...commonLocales, ...nonProdLocales] as const);

type ExtractTypeFromArray<T extends Iterable<unknown>> = T extends Iterable<
    infer E
>
    ? E
    : never;

export type SupportedLocales = ExtractTypeFromArray<typeof VALID_LOCALES>;

export const isValidLocale = (locale: string): locale is SupportedLocales =>
    VALID_LOCALES.includes(locale);

export const delocalizePathname = (pathname: string) => {
    const regex = new RegExp(`^/(${VALID_LOCALES.join("|")})`);
    return pathname.replace(regex, "");
};

export const isEqualUnlocalizedPathname = (
    pathname_a: string,
    pathname_b: string
) => {
    if (!pathname_a || !pathname_b) {
        return false;
    }

    const a = delocalizePathname(pathname_a);
    const b = delocalizePathname(pathname_b);

    return a === b;
};
